// import en from './messages/en';
import es from './messages/es';

export default {
    // en,
    es,
};